import { render, staticRenderFns } from "./AccountsReceivablePaymentsProductsServices.vue?vue&type=template&id=5bf10cfc&scoped=true"
import script from "./AccountsReceivablePaymentsProductsServices.vue?vue&type=script&lang=js"
export * from "./AccountsReceivablePaymentsProductsServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf10cfc",
  null
  
)

export default component.exports